import { ReprocessBlocker, ReprocessBlockerKind, ReprocessRecognitionResult } from '@lite-workspace/dto-fotoclass-common';

/**
 * RU copy for reprocess blockers. Диалог обязан называть последствия своими именами:
 * не «есть альбом», а что именно останется привязанным к осиротевшим персонам.
 */
export const REPROCESS_BLOCKER_LABEL: Record<ReprocessBlockerKind, string> = {
  personIdentityReset:
    'Персоны будут пересозданы с новыми идентификаторами — книги, имена и ручные виньетки останутся привязаны к старым',
  namedPerson: 'Именованные ученики потеряют связь имени с новыми фото',
  vignetteEdit: 'Ручные виньетки (кроп) не переедут на пересозданные персоны',
  manualBinding: 'Подтверждённые вручную привязки лиц будут погашены',
  assembledAlbum: 'Готовые альбомы держат вёрстку на текущих персонах',
};

export interface ReprocessPlanView {
  /** Построчное описание объёма работ для диалога подтверждения. */
  lines: string[];
  /** Список последствий, каждое с числом задетых сущностей. */
  blockers: { label: string; count: number }[];
  /** Есть блокеры → подтверждение красное и боевой вызов уходит с force. */
  danger: boolean;
}

export function describeReprocessPlan(plan: ReprocessRecognitionResult): ReprocessPlanView {
  const lines: string[] = [
    `Файлов к переобработке: ${plan.targetFiles}`,
    `Лиц будет погашено: ${plan.facesDiscarded}`,
    `Задач распознавания будет отправлено: ${plan.dispatched}`,
  ];
  if (plan.skipped.length > 0) {
    lines.push(`Будет пропущено (нет прежнего распознавания): ${plan.skipped.length}`);
  }

  const blockers = plan.blockers.map((blocker: ReprocessBlocker) => ({
    label: REPROCESS_BLOCKER_LABEL[blocker.kind] ?? blocker.kind,
    count: blocker.ids.length,
  }));

  return { lines, blockers, danger: blockers.length > 0 };
}
